var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("approval.period.menu")))]),_c('approval-period',{attrs:{"data-test":"periodic-update-page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }